import { useEffect, useState } from "react";
import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
// import {  } from "../components/ui/table";
import { Textarea } from "../components/ui/textarea";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  
} from "../components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  
} from "../components/ui/dialog";
import {
  Check,
  X,
  Eye,
  Clock,
  CheckCircle,
  XCircle,
  User,
  Calendar,
  Building2,
  AlertCircle,
  FileText,
  Package,

} from "lucide-react";
import {
  get_pending_po_for_owner,
  owner_approve_po,
  owner_reject_po,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery.js";
import Loader from "../components/layout/Loader.js";

export default function OwnerPOApproval() {
  const [poList, setPOList] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [showApproveDialog, setShowApproveDialog] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const designation_name = retrieveData("designation_name");
  console.log(designation_name);
  useEffect(() => {
    fetchPendingPOs();
  }, []);

  const fetchPendingPOs = async () => {
    setLoading(true);
    const fd = new FormData();
    await server_post_data(get_pending_po_for_owner, fd)
      .then((response) => {
        if (response.data.error) {
          handleError(response.data.message);
        } else {
          setPOList(response.data.message.list || []);
        }
      })
      .catch(() => handleError("Network error"))
      .finally(() => setLoading(false));
  };

  const handleApprove = async () => {
    if (!selectedPO) return;

    const fd = new FormData();
    fd.append("purchase_id", selectedPO.purchase_id);
    fd.append("remarks", remarks);

    setShowApproveDialog(false);
    setLoading(true);

    await server_post_data(owner_approve_po, fd)
      .then((response) => {
        if (response.data.error) {
          handleError(response.data.message);
        } else {
          handleSuccess("Approved", "PO approved successfully! PDF generated.");
          fetchPendingPOs();
        }
      })
      .catch(() => handleError("Failed to approve"))
      .finally(() => {
        setLoading(false);
        setRemarks("");
        setSelectedPO(null);
      });
  };

  const handleReject = async () => {
    if (!selectedPO || !remarks.trim()) {
      handleError("Please provide a rejection reason");
      return;
    }

    const fd = new FormData();
    fd.append("purchase_id", selectedPO.purchase_id);
    fd.append("remarks", remarks);

    setShowRejectDialog(false);
    setLoading(true);

    await server_post_data(owner_reject_po, fd)
      .then((response) => {
        if (response.data.error) {
          handleError(response.data.message);
        } else {
          handleSuccess("Rejected", "PO rejected successfully.");
          fetchPendingPOs();
        }
      })
      .catch(() => handleError("Failed to reject"))
      .finally(() => {
        setLoading(false);
        setRemarks("");
        setSelectedPO(null);
      });
  };

  const getStatusBadge = (statusNum) => {
    switch (statusNum) {
      case 1:
        return (
          <Badge
            variant="outline"
            className="bg-amber-50 text-amber-700 border-amber-300"
          >
            <Clock className="w-3 h-3 mr-1" />
            Pending Approval
          </Badge>
        );
      case 2:
        return (
          <Badge
            variant="outline"
            className="bg-emerald-50 text-emerald-700 border-emerald-300"
          >
            <CheckCircle className="w-3 h-3 mr-1" />
            Approved
          </Badge>
        );
      case 3:
        return (
          <Badge
            variant="outline"
            className="bg-red-50 text-red-700 border-red-300"
          >
            <XCircle className="w-3 h-3 mr-1" />
            Rejected
          </Badge>
        );
      default:
        return <Badge variant="outline">Unknown</Badge>;
    }
  };

  return (
    <MainLayout>
      <Header
        title="PO Approval"
        subtitle="Review and approve/reject Purchase Orders requiring your approval"
      />

      {loading && <Loader />}

      <div className="p-6 space-y-6">
        {/* Workflow */}
        <div className="flex items-center justify-center gap-4 text-sm">
          <span className="px-2 py-1 rounded bg-muted text-muted-foreground">
            1. Create PO
          </span>
          <span className="text-muted-foreground">→</span>
          <span className="px-2 py-1 rounded bg-primary/20 text-primary font-medium">
            2. Owner Approval
          </span>
          <span className="text-muted-foreground">→</span>
          <span className="px-2 py-1 rounded bg-muted text-muted-foreground">
            3. Vendor Order
          </span>
          <span className="text-muted-foreground">→</span>
          <span className="px-2 py-1 rounded bg-muted text-muted-foreground">
            4. GRN
          </span>
        </div>

        {/* Stats Cards - No Price Info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card className="bg-card border-border">
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">
                    Pending Your Approval
                  </p>
                  <p className="text-2xl font-bold text-amber-600">
                    {poList.filter((p) => p.approve_status_num === 1).length}
                  </p>
                </div>
                <Clock className="w-8 h-8 text-amber-500" />
              </div>
            </CardContent>
          </Card>

          <Card className="bg-card border-border">
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">
                    Approved by You
                  </p>
                  <p className="text-2xl font-bold text-emerald-600">
                    {poList.filter((p) => p.approve_status_num === 2).length}
                  </p>
                </div>
                <CheckCircle className="w-8 h-8 text-emerald-500" />
              </div>
            </CardContent>
          </Card>

          <Card className="bg-card border-border">
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">
                    Rejected by You
                  </p>
                  <p className="text-2xl font-bold text-red-600">
                    {poList.filter((p) => p.approve_status_num === 3).length}
                  </p>
                </div>
                <XCircle className="w-8 h-8 text-red-500" />
              </div>
            </CardContent>
          </Card>
        </div>

        {/* PO List Table - No Price Columns */}
        <Card className="bg-card border-border">
          <CardHeader>
            <CardTitle>Purchase Orders for Approval</CardTitle>
            <CardDescription>
              Only POs requiring your approval are shown
            </CardDescription>
          </CardHeader>
          <CardContent>
            {poList.length === 0 ? (
              <div className="text-center py-8 text-muted-foreground">
                <AlertCircle className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p>No POs pending for your approval</p>
              </div>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>PO Number</TableHead>
                    <TableHead>Created By</TableHead>
                    <TableHead>Department</TableHead>
                    <TableHead>Vendor</TableHead>
                    <TableHead>Date</TableHead>
                    <TableHead className="text-center">Items</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead className="text-center">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {poList.map((po) => (
                    <TableRow
                      key={po.purchase_id}
                      className="hover:bg-muted/30"
                    >
                      <TableCell className="font-medium text-primary">
                        {po.purchase_no}
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <User className="w-4 h-4 text-muted-foreground" />
                          {po.admin_name}
                        </div>
                      </TableCell>
                      <TableCell>
                        <Badge variant="outline">{po.department_name}</Badge>
                      </TableCell>
                      <TableCell>{po.vendor_name}</TableCell>
                      <TableCell>
                        {new Date(po.entry_date).toLocaleDateString("en-IN")}
                      </TableCell>
                      <TableCell className="text-center">
                        {po.total_items}
                      </TableCell>
                      <TableCell>
                        {getStatusBadge(po.approve_status_num)}
                      </TableCell>
                      <TableCell className="text-center">
                        <div className="flex items-center justify-center gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setSelectedPO(po)}
                          >
                            <Eye className="w-4 h-4 mr-1" />
                            View 
                          </Button>
                          {(po.approve_status_num) === 1 &&
                              designation_name?.trim().toLowerCase() === "owner" && (
                            <>
                            
                              <Button
                                size="sm"
                                className="bg-emerald-600 hover:bg-emerald-700"
                                onClick={() => {
                                  setSelectedPO(po);
                                  setShowApproveDialog(true);
                                }}
                              >
                                <Check className="w-4 h-4" />
                              </Button>
                              <Button
                                variant="destructive"
                                size="sm"
                                onClick={() => {
                                  setSelectedPO(po);
                                  setShowRejectDialog(true);
                                }}
                              > 
                                <X className="w-4 h-4" />
                              </Button>
                            </>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>

        {/* View Dialog - No Price Info */}
        <Dialog
          open={!!selectedPO && !showApproveDialog && !showRejectDialog}
          onOpenChange={() => setSelectedPO(null)}
        >
          <DialogContent className="max-w-3xl">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <FileText className="w-5 h-5" />
                {selectedPO?.purchase_no}
              </DialogTitle>
              <DialogDescription>Purchase Order Details</DialogDescription>
            </DialogHeader>

            {selectedPO && (
              <div className="space-y-6">
                {/* Basic Info */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="space-y-1">
                    <p className="text-xs text-muted-foreground">Created By</p>
                    <p className="font-medium flex items-center gap-1">
                      <User className="w-4 h-4" />
                      {selectedPO.admin_name}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs text-muted-foreground">Department</p>
                    <p className="font-medium flex items-center gap-1">
                      <Building2 className="w-4 h-4" />
                      {selectedPO.department_name}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs text-muted-foreground">Vendor</p>
                    <p className="font-medium">{selectedPO.vendor_name}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs text-muted-foreground">Date</p>
                    <p className="font-medium flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {new Date(selectedPO.entry_date).toLocaleDateString(
                        "en-IN"
                      )}
                    </p>
                  </div>
                </div>

                {/* Items Table - No Rate/Total */}
                <div className="space-y-3">
                  <h4 className="font-semibold flex items-center gap-2">
                    <Package className="w-5 h-5" />
                    Items ({selectedPO.total_items})
                  </h4>
                  <div className="border rounded-lg overflow-hidden">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Sr.No</TableHead>
                          <TableHead>Item Name</TableHead>
                          <TableHead className="text-center">
                            Quantity
                          </TableHead>
                          <TableHead>Unit</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {selectedPO.items && selectedPO.items.length > 0 ? (
                          selectedPO.items.map((item, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell className="font-medium">
                                     <div className="flex flex-col gap-0">
                                    {/* 1. Primary: Alter Name (Bold & Main) */}
                                    <span className="text-sm font-semibold text-foreground leading-tight">
                                      {item.item_alter_name || item.item_name || "—"}
                                    </span>

                                    {/* 2. Secondary: Original Name (Subtle & Small) */}
                                    {item.item_alter_name && 
                                      item.item_name && 
                                      item.item_alter_name.trim().toLowerCase() !== item.item_name.trim().toLowerCase() && (
                                        <span className="text-[11px] text-muted-foreground font-medium italic opacity-80 leading-none">
                                          {item.item_name}
                                        </span>
                                    )}
                                  </div>
                              </TableCell>
                              <TableCell className="text-center">
                                {item.item_qty}
                              </TableCell>
                              <TableCell>
                                {item.item_unit_type || "Unit"}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              className="text-center text-muted-foreground"
                            >
                              No items
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </div>

                {/* Status */}
                <div className="flex items-center justify-between pt-4 border-t">
                  <div className="flex items-center gap-2">
                    <span className="text-muted-foreground">Status:</span>
                    {getStatusBadge(selectedPO.approve_status_num)}
                  </div>
                </div>

                {/* Remarks */}
                {selectedPO.remarks && (
                  <div className="space-y-2">
                    <h4 className="font-semibold flex items-center gap-2">
                      <AlertCircle className="w-5 h-5" />
                      Remarks
                    </h4>
                    <div className="p-4 border rounded-lg bg-muted/30">
                      <p className="text-sm">{selectedPO.remarks}</p>
                    </div>
                  </div>
                )}
              </div>
            )}

            <DialogFooter>
              {(selectedPO?.approve_status_num) === 1 &&
                              designation_name?.trim().toLowerCase() === "owner" && (
                <>
                  <Button
                    variant="destructive"
                    onClick={() => setShowRejectDialog(true)}
                  >
                    <X className="w-4 h-4 mr-1" />
                    Reject
                  </Button>
                  <Button
                    className="bg-emerald-600 hover:bg-emerald-700"
                    onClick={() => setShowApproveDialog(true)}
                  >
                    <Check className="w-4 h-4 mr-1" />
                    Approve
                  </Button>
                </>
              )}
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Approve & Reject Dialogs remain same (no price shown) */}
        <Dialog open={showApproveDialog} onOpenChange={setShowApproveDialog}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle className="text-emerald-600">
                Approve Purchase Order
              </DialogTitle>
              <DialogDescription>
                Approve {selectedPO?.purchase_no} for vendor order placement
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div className="space-y-2">
                <label className="text-sm font-medium">
                  Remarks (Optional)
                </label>
                <Textarea
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Add any notes..."
                  rows={3}
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => setShowApproveDialog(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-emerald-600 hover:bg-emerald-700"
                onClick={handleApprove}
              >
                <Check className="w-4 h-4 mr-1" />
                Confirm Approval
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog open={showRejectDialog} onOpenChange={setShowRejectDialog}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle className="text-destructive">
                Reject Purchase Order
              </DialogTitle>
              <DialogDescription>
                Reject {selectedPO?.purchase_no} and send back to staff
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div className="bg-red-50 dark:bg-red-950 p-4 rounded-lg">
                <p className="text-sm text-red-700 dark:text-red-300">
                  This PO will be sent back for revision.
                </p>
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium">
                  Reason for Rejection *
                </label>
                <Textarea
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Provide a reason..."
                  rows={3}
                  required
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => setShowRejectDialog(false)}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                onClick={handleReject}
                disabled={!remarks.trim()}
              >
                <X className="w-4 h-4 mr-1" />
                Confirm Rejection
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </MainLayout>
  );
}
